<script lang="ts">
  import { Table } from 'sveltestrap'
  import Pagination from 'src/components/#common/pagination/Pagination.svelte'
  import PerPage from 'src/components/#common/pagination/PerPage.svelte'
  import {getAllTransactionWithFilter} from 'src/components/cabinet/#services/getAllTransactionWithFilter'

  export let internalUserId = undefined;

  let currentPage = 0
  let perPage = 25
  let maxButtons = 5
  let game = 'all'
  let debitCredit = 'all'
  let reason = 'all'
  let fromDate = 'firstDate'
  let toDate = 'lastDate'
  let loadingTransactions = []

  loadingTransactions.length = perPage

  let maxDate = new Date()
  let dd = String(maxDate.getDate()).padStart(2, '0')
  let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
  let yyyy = maxDate.getFullYear()
  maxDate = yyyy+'-'+mm+'-'+dd

  function filter() {
      getAllTransactionWithFilter.send({
          data:{
              filterList:{
                  userId: internalUserId,
                  reason: reason,
                  creator: game,
                  TypeTransaction: debitCredit,
                  firstDate: fromDate,
                  lastDate: toDate,
                  page: currentPage + 1,perPage
              }
          }
      })
      $getAllTransactionWithFilter.value
  }
  $:currentPage,perPage,filter()

  function reset() {
      game = 'all'
      debitCredit = 'all'
      reason = 'all'
      fromDate = 'firstDate'
      toDate = 'lastDate'
      filter()
  }

  function isObject(obj) {
      return typeof obj === 'object'
  }
</script>

<div class="buttons">
    <div class="pc-line">
        <span class="date-label">Game</span>
        <select class="form-select" bind:value={game}>
            <option value="all">All</option>
            <option value="cats">Merge Cats</option>
            <option value="dragons">Crypto Dragons</option>
            <option value="foxes">Crypto Fox</option>
            <option value="dogs">Crypto DOGE</option>
            <option value="elon">Elon Game</option>
        </select>
    </div>
    <div class="pc-line">
        <span class="date-label">Debit/Credit</span>
        <select class="form-select" bind:value={debitCredit}>
            <option value="all">All</option>
            <option value="debit">Debit only</option>
            <option value="credit">Credit only</option>
        </select>
    </div>
    <div class="pc-line">
        <span class="date-label">Reason</span>
        <select class="form-select" bind:value={reason}>
            <option value="all">All</option>
            <option value="1,31">Spin debit</option>
            <option value="2,32">Spin credit</option>
            <option value="3">Survey</option>
            <option value="4">Chest opening</option>
            <option value="5">Deposit from site</option>
            <option value="6">Subscription purchase</option>
            <option value="7">Consumable purchase</option>
            <option value="8">Exchange</option>
            <option value="9">Tournament</option>
            <option value="10">Subscription purchase</option>
            <option value="11">Upgrade cat</option>
            <option value="12">Mew bonus</option>
            <option value="13">Offline earning</option>
            <option value="14">Speed boost</option>
            <option value="15">Unit purchase</option>
            <option value="16,17">Administrator action</option>
            <option value="18">Achievement</option>
            <option value="19">Task</option>
            <option value="20">Referral task</option>
            <option value="21">Referrer reward</option>
            <option value="22">Purchase offer</option>
            <option value="23">Unlink exchange</option>
            <option value="24">Lootbox reward</option>
            <option value="25,38,40,42">Lootbox purchase</option>
            <option value="26">Exchange</option>
            <option value="27">Science</option>
            <option value="28">Swap</option>
            <option value="29">Bingo jackpot</option>
            <option value="30">Bingo reward</option>
            <option value="walletTransfer">Wallet Transfer</option>
            <option value="increase">Increase</option>
            <option value="decrease">Decrease</option>
            <option value="purchase">Game purchase</option>
            <option value="withdrawal">Withdrawal</option>
            <option value="adminManualFixBalance">Administrator action</option>
            <option value="adminRollback">Administrator action</option>
            <option value="adminManualMergeAccount">Administrator action</option>
            <option value="changeNickname">Nickname change</option>
            <option value="lootbox">Game Purchase</option>
            <option value="depositBlockchain">Deposit</option>
            <option value="nearTestnet">Increase</option>
            <option value="staking">Staking</option>
        </select>
    </div>
    <div class="pc-line">
        <span class="date-label">From</span>
        <input type="date" bind:value={fromDate} class="form-control" max="{maxDate}">
    </div>
    <div class="pc-line">
        <span class="date-label">To</span>
        <input type="date" bind:value="{toDate}" class="form-control" max="{maxDate}">
    </div>
    <div class="pc-line">
        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
        <button class="btn btn-secondary" on:click={reset}>Reset</button>
    </div>
</div>
{#if $getAllTransactionWithFilter.hasValue}
    <PerPage
        bind:perPage={perPage}
        disabled={$getAllTransactionWithFilter.loading || $getAllTransactionWithFilter.loading}
        totalCount={$getAllTransactionWithFilter.value.totalCount}
    />
{/if}
<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Date</td>
            <td class="text-center">Amount</td>
            {#if !internalUserId}
            <td class="text-center">User</td>
            {/if}
            <td class="text-center">Description</td>
        </tr>
        </thead>
        <tbody>
        {#if $getAllTransactionWithFilter.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getAllTransactionWithFilter.error || !$getAllTransactionWithFilter.hasValue }
            <tr>
                <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getAllTransactionWithFilter.value.data as { createdAt, credit, debit, currency, reason, txId,userId}}
                <tr>
                    <td class="text-center">{new Date(createdAt).toLocaleString()}</td>
                    <td class="text-center nobr notranslate">
                {#if debit > 0}
                    <span class="text-success">+{`${debit.split('.')[0]}${debit.split('.')[1] ? '.' : ''}${debit.split('.')[1]?.slice(0, 4) || ''}`} {#if currency === 'WLIS' || currency === 'TLIS'}LIS{:else}{currency}{/if}</span>
                {:else if credit > 0}
                    <span class="text-danger">-{`${credit.split('.')[0]}${credit.split('.')[1] ? '.' : ''}${credit.split('.')[1]?.slice(0, 4) || ''}`} {#if currency === 'WLIS' || currency === 'TLIS'}LIS{:else}{currency}{/if}</span>
                {:else}
                    <span>0 {#if currency === 'WLIS' || currency === 'TLIS'}LIS{:else}{currency}{/if}</span>
                {/if}
                </td>
                {#if !internalUserId}
                  <td class="text-center">
                    {#if userId}
                        <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">{userId}</a>
                    {/if}
                  </td>
                {/if}
                    <td>
                        {#if isObject(reason)}
                            {Object.values(JSON.parse(reason))[0]}
                        {:else if reason !== '{}'}
                            {reason}
                        {/if}
                    </td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="4">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getAllTransactionWithFilter.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getAllTransactionWithFilter.value.totalCount}
            bind:perPage={perPage}
            {maxButtons}
            disabled={$getAllTransactionWithFilter.loading || $getAllTransactionWithFilter.loading}
        />
    {/if}
</div>

<style>
  .buttons {
      margin-bottom: 15px;
  }

  .buttons .btn {
      margin-left: 5px;
  }

  .transaction-loading {
      height: 24px;
      width: 100%;
      display: block;
  }

  .btn-primary.btn-filter {
      padding: 8px 20px;
  }

  .form-select {
      width: auto;
      display: inline-block;
      vertical-align: top;
  }

  input[type="date"] {
      width: auto;
      display: inline-block;
      vertical-align: top;
  }

  .date-label {
      padding: 0 5px;
      line-height: 38px;
      font-weight: 500;
  }

  .btn.btn-secondary {
      padding: 10px 20px;
      font-size: 14px;
      line-height: normal;
      border: 0;
      box-shadow: none;
  }

  .btn.active {
      background: #FF5D1C;
  }

  .pc-line {
      display: inline-block;
      margin-bottom: 10px;
  }

  @media(max-width: 767px) {
      .pc-line {
          display: block;
      }

      .pc-line .btn {
          margin-left: 0;
          width: 100%;
      }

      .date-label {
          font-size: 14px;
      }

      .btn-filter {
          margin-bottom: 10px;
      }
  }
</style>
